import { styled } from '@linaria/react';
import { primitives, radius, semantic, size, space, textStyle } from '../../theme/tokens';

export const ToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-200']};
  padding: ${space['space-100']};
  border-radius: ${radius('button', 'radius-full')};
  background: ${semantic.bg.surfaceSubtle};
`;

export const ToggleButton = styled.a<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-100']};
  height: ${primitives.size['size-1000']};
  padding: ${space['space-100']} ${space['space-400']};
  border: none;
  border-radius: ${radius('button', 'radius-full')};
  background: ${({ $active }) => ($active ? semantic.bg.secondary : 'transparent')};
  color: ${semantic.icon.primary};
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s ease;

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }
`;

export const ToggleLabel = styled.span`
  font-family: ${textStyle.body.md.strong.fontFamily};
  font-size: ${textStyle.body.md.strong.fontSize};
  font-weight: ${textStyle.body.md.strong.fontWeight};
  line-height: ${textStyle.body.md.strong.lineHeight};
  letter-spacing: ${textStyle.body.md.strong.letterSpacing};
  white-space: nowrap;
`;
